module.exports = __webpack_public_path__ + "img/Menu-04.15a31d90.png";